import { render, staticRenderFns } from "./RegRecipe.vue?vue&type=template&id=1e5b4e30&scoped=true"
import script from "./RegRecipe.vue?vue&type=script&lang=js"
export * from "./RegRecipe.vue?vue&type=script&lang=js"
import style0 from "./RegRecipe.vue?vue&type=style&index=0&id=1e5b4e30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5b4e30",
  null
  
)

export default component.exports